import { SOPSendType } from "../../constants";

export enum EntityType {
  // CUSTOMER = 'CHAT_CUSTOMER' 字段改成了CUSTOMER_SOP,
  // CUSTOMER = "CHAT_CUSTOMER",
  CUSTOMER = "CUSTOMER_SOP",
  GROUP = "CHAT_SOP",
}

export enum ActionStatus {
  UN_SEND = "UN_SEND",
  SEND_SUCCESS = "SEND_SUCCESS",
  SEND_FAILURE = "SEND_FAILURE",
}

export enum ActionMessage {
  HAS_NO_DELIVERY = "HAS_NO_DELIVERY",
  HAS_DELIVERY = "HAS_DELIVERY",
  NOT_FRIEND = "NOT_FRIEND",
  LIMIT = "LIMIT",
}

export interface SendEntity {
  userId: string; // 执行客服ID、群主ID
  entityId: string; // 实体ID：客户ID、群ID
  entityName: string; // 实体名称：客户名称、群名称
  avatar: string; // 头像
  entityType: EntityType; // 实体类型：CUSTOMER("客户SOP"), GROUP("群SOP")
  actionStatus: ActionStatus; // 操作状态：未发送、发送成功、发送失败
  actionMessage: ActionMessage; // 操作结果信息：未送达、已送达、客户接收达上限、已不是好友客户
  sopSendType: SOPSendType; // 发送方式：快捷发送、一键发送
  executeTime: string; // 发送时间
}
